import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../mock/mock';

const LangContext = createContext({ lang: 'en', t: translations.en, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('dn_lang') || 'en'; } catch { return 'en'; }
  });

  useEffect(() => {
    try { localStorage.setItem('dn_lang', lang); } catch {}
    const dir = translations[lang].dir;
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, t, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
